import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagCM = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M35.87 2.48A24.901 24.901 0 0 0 25 0c-3.895 0-7.583.891-10.87 2.48L11.957 25l2.175 22.52A24.9 24.9 0 0 0 25 50a24.9 24.9 0 0 0 10.87-2.48L38.044 25 35.87 2.48Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m25 16.304 2.158 6.643h6.985l-5.65 4.106 2.158 6.643L25 29.59l-5.651 4.106 2.159-6.643-5.651-4.106h6.985L25 16.304Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M14.13 2.481C5.768 6.525 0 15.088 0 25c0 9.911 5.768 18.475 14.13 22.518V2.481Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M35.87 2.481v45.037C44.232 43.475 50 34.911 50 25c0-9.912-5.768-18.475-14.13-22.519Z"
}));
FlagCM.displayName = 'FlagCM';
export default withFlagWrapper(FlagCM);
//# sourceMappingURL=index.js.map